export default __webpack_public_path__ + "static/media/Volume Down.c7ae3493.svg";